












import { Component, Vue, Prop } from 'vue-property-decorator'
import { projectListLocalisationKeys } from '@/features/projectList/projectList.localisation'

@Component
export default class BackBtn extends Vue {
  private translations = projectListLocalisationKeys
  private goBack () {
    this.$router.go(-1)
  }
}
